import React from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import checkWhite from '../../../assets/icons/check-white-thick.svg';
import { ReactSVG } from 'react-svg';
import {theme} from '../../../themes/default-theme';
import { ButtonBase } from '@mui/material';

const Container = styled.ul`
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 220px;
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0 auto;

    &:before {
        content: '';
        height: 7px;
        width: calc(100% - 6px);
        left: 3px;
        position: absolute;
        top: 6.5px;
        background-color: #D9D9D9;
    }
`

const Step = styled.li`
    display: inline-block;
    vertical-align: middle;
    position: relative;
`

const Tick = styled(ButtonBase)`
    background-color: ${theme.palette.gunmentalGrey};
    display:block;
    width: 20px;
    height: 20px;
    border: 2px solid white;
    border-radius: 20px;
    position: relative;
    margin-top: 0;

    svg {
        width: 10px;
        height: auto;
        display: block;
        margin-left: 4px;
    }

    &:hover {
        span {
            display: block;
        }
    }
`

const Number = styled.span`
    width: 20px;
    height: 20px;
    border: 2px solid white;
    border-radius: 20px;
    background-color: ${theme.palette.gunmentalGrey};
    display:block;
    color: white;
    text-align: center;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;

    ${props => props.active && `
        background-color: ${theme.palette.vividBlue};
    `}
`

const Popup = styled.span`
    position: absolute;
    background-color: ${theme.palette.charcoal};
    color: white;
    border-radius: 6px;
    font-weight: bold;
    bottom: 100%;
    width: 123px;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 0;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-size: 12px;
    display: none;

    &:after {
        content: "";
        width: 0; 
        height: 0; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid ${theme.palette.charcoal};
        position: absolute;
        right: 50%;
        margin-right: -10px;
        bottom: -10px;
    }

    a {
        font-weight: normal;
        color: white;
        text-transform: initial;
    }
`

const progressBarDefaultPropOnChange = () => {};

const ProgressBar = ({
    steps = 4,
    active = 1,
    onChange = progressBarDefaultPropOnChange,
    state
}) => {
    const items = Array(steps).fill(0);
    
    return (
    	<Container>
            {items.map((item, index) => {
                const number = index + 1;
                const isComplete = number < active ? true : false;
                const isActive = number === active;

                let popup = null

                if (index === 0 && state.exp && state.exp.length > 0) {
                    popup = state.exp === 'tow' ? 'Tow it' : 'Drive it'
                }
                
                if (index === 1 && state.expTow && state.expTow.text && state.expTow.text.length > 0 && state.exp === 'tow') {
                    popup = state.expTow.text
                }
                
                if (index === 2 && state.howMany && state.howMany.adults > 0) {
                    popup = `${state.howMany.adults} adults`
                    if (state.howMany.children) {
                        popup += ` ${state.howMany.children} kids`
                    }
                }
                
                if (index === 3 && state.adventure && state.adventure.length > 0) {
                    popup = state.adventure
                }

                return (
                    <Step key={index}>
                        {isComplete ?
                            <Tick onClick={() => onChange(index + 1)}>
                                <ReactSVG src={checkWhite} />
                                {popup && popup.length > 0 &&
                                    <Popup>
                                        {popup}
                                        <br />
                                        <a href="javascript:;">Edit</a>
                                    </Popup>
                                }
                            </Tick>
                        :
                            <Number active={isActive}>{number}</Number>
                        }
                    </Step>  
                )
            })}
        </Container>
    )
}

ProgressBar.propTypes = {
}

export default ProgressBar